import { useParams } from "react-router-dom";
import HomeLayout from "../../commonComponents/HomeLayout";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import { useEffect } from "react";
import { fetchBlogAsync, fetchBlogsAsync } from "../../../../apis/blogs/blogs";
import BlogDetails from "./BlogDetails";
import { Link } from "react-router-dom";

const Blog = () => {
  const { slug } = useParams<{ slug: string }>();
  const dispatch = useDispatch<AppDispatch>();

  const { blog, blogs, loading, error } = useSelector(
    (state: RootState) => state.blogs
  );

  useEffect(() => {
    if (slug) {
      dispatch(fetchBlogAsync(slug));
    }
  }, [slug, dispatch]);

  useEffect(() => {
    if (blogs.length === 0) {
      dispatch(fetchBlogsAsync());
    }
  }, [blogs.length, dispatch]);

  return (
    <HomeLayout showMarquee={false}>
      <div className="w-full flex justify-center px-5">
        <div className="max-w-[1156px] w-full flex flex-col gap-8 pt-14">
          <div className="flex text-sm md:text-base items-center text-[20px] gap-3 text-textGrey">
            <Link to={"/insights-stories"}>Insights</Link>
            <ArrowForwardIosIcon fontSize="small" />
            <span className="font-semibold text-textBlack">Details</span>
          </div>

          {loading && (
            <div className="w-full h-[60vh] flex items-center justify-center">
              <div className="payment-loader" />
            </div>
          )}

          {!loading && error && (
            <div className="w-full items-center justify-center h-[60vh] flex">
              <p className="text-red-500 text-lg text-center">
                Failed to load. Please try again later.
                <br />
                <span className="text-sm text-gray-500">Error: {error}</span>
              </p>
            </div>
          )}

          {!loading && !error && blog && blog.length > 0 && (
            <BlogDetails blogs={blogs} blog={blog[0]} />
          )}
        </div>
      </div>
    </HomeLayout>
  );
};

export default Blog;
